var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('div',{class:{'center-slot-wrapper': true, without: _vm.lift},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }